"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
var _postDetail = _interopRequireDefault(require("./postDetail.vue"));
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'expandList',
  components: {
    postDetail: _postDetail.default
  },
  props: {
    actId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('actId', newVal);
        // 有actId时选中，无actId时不选
        if (newVal && newVal != 'null' && newVal != '') {
          this.searchForm.taskId = Number(newVal);
          this.searchForm.page = 1;
          this.fetchList();
        }
        this.searchForm.taskId = newVal && newVal != 'null' ? newVal : '';
      }
    }
  },
  data: function data() {
    return {
      rewardNum: '',
      loading: false,
      searchForm: {
        auditType: 'post',
        // 固定值
        startTime: '',
        endTime: '',
        action: '',
        // 默认按基础帖审核
        status: '',
        taskId: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      },
      times: [],
      // 菜单激活项：basic | premium
      activeMenu: 'basic',
      actLists: [],
      tableData: [],
      // 人工审核弹窗
      showReviewDialog: false,
      currentRow: null,
      reviewForm: {
        status: '',
        // 'reject' | 'pass' | 'pass_no_reward'
        reward: '',
        // 仅优质帖使用: '20' | '50'
        remark: '',
        qualityLevel: null
      },
      reviewFormRules: {
        status: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        remark: [{
          required: false,
          message: '请填写备注',
          trigger: 'blur'
        }]
      },
      showPostDialog: false,
      selectedPost: null,
      postLoading: false,
      downloadLoading: false,
      extraRewards: []
    };
  },
  computed: {
    taskTimeDisplay: function taskTimeDisplay() {
      if (this.currentRow.validType == 2) {
        return '长期有效';
      }
      var start = this.formatDate(this.currentRow.validStartTime);
      var end = this.formatDate(this.currentRow.validEndTime);
      return "".concat(start, " - ").concat(end);
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      if (!date) return '';
      // 示例：格式化为 YYYY-MM-DD HH:mm
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes);
    },
    postDetail: function postDetail(row, type) {
      var _this = this;
      var id = "";
      if (type == 0) {
        id = row.postId;
      } else {
        id = row.matchPostId;
      }
      this.postLoading = true;
      this.selectedPost = null;
      _redbook.default.getPostDetail(id).then(function (res) {
        console.log(res);
        //res.data.cardNo = row.cardNo || '';
        //res.data.mobile = row.mobile || '';

        _this.selectedPost = res && (res.data || res) || {};
        //this.selectedPost.taskName = row.taskName
        // 仅在拿到数据后再显示弹窗，避免子组件提前渲染导致错误
        _this.showPostDialog = true;
      }).catch(function (err) {
        _this.$message.error(err && err.message ? err.message : '获取帖子详情失败');
      }).finally(function () {
        _this.postLoading = false;
      });
    },
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    download: function download() {
      this.downloadLoading = true;
      var params = {
        status: this.searchForm.status,
        taskId: this.searchForm.taskId,
        mobile: this.searchForm.mobile,
        cardNo: this.searchForm.cardNo
      };
      // redBookApi.exportData(params).then((response) => {
      //     const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
      //     const link = document.createElement('a');
      //     link.href = window.URL.createObjectURL(blob);
      //     link.download = '膨胀明细.xlsx';
      //     link.click();
      //     window.URL.revokeObjectURL(link.href);

      // }).finally(() => {
      //     this.downloadLoading = false
      // });
    },
    changeTime: function changeTime(e) {
      console.log(e);
      console.log(e);
      if (!e || e.length === 0) {
        // 清除筛选条件
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    // 菜单切换：基础帖 / 优质帖
    handleMenuSelect: function handleMenuSelect(key) {
      this.activeMenu = key;
      this.searchForm.auditType = key === 'basic' ? 'post' : 'quality';
      this.searchForm.page = 1;
      this.searchForm.status = '';
      this.searchForm.action = '';
      this.searchForm.cardNo = '';
      this.searchForm.mobile = '';
      this.searchForm.startTime = '';
      this.searchForm.endTime = '';
      this.times = [];
      this.fetchList();
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      console.log(this.searchForm);
      _redbook.default.postAudit(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          if (item.remark && item.remark != '') {
            try {
              item.remark = JSON.parse(item.remark);
            } catch (error) {
              item.remark = ''; // 或 item.remark2 = item.remark;
            }
          } else {
            // 如果 remark 为空，设置默认值
            item.remark = '';
          }
          item.createTime = _this2.dateFormat2(item.createTime, 'yyyy-MM-dd HH:mm:ss');
        });
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    postAllreward: function postAllreward() {
      var _this3 = this;
      var type = this.activeMenu === 'basic' ? '1' : '2';
      _redbook.default.rewardAll({
        type: type
      }).then(function (res) {
        if (res.code == 500) {
          _this3.$message.error(res.message);
          return;
        }
        _this3.$message.success('发放成功');
        _this3.fetchList();
      });
    },
    postReward: function postReward(row) {
      var _this4 = this;
      _redbook.default.rewardById(row.id).then(function (res) {
        if (res.code == 500) {
          _this4.$message.error(res.message);
          return;
        }
        _this4.$message.success('发放成功');
        _this4.fetchList();
      });
    },
    postReview: function postReview(row, id) {
      var _this5 = this;
      this.rewardNum = '';
      var postId = row.postId + '';
      console.log("postId", postId, (0, _typeof2.default)(postId));
      _redbook.default.getRewardNum({
        postId: postId
      }).then(function (res) {
        // if (res.code !== 200) return;
        _this5.rewardNum = res.message || '';
      });
      if (this.activeMenu == 'premium') {
        _redbook.default.getTaskDetail(row.taskId).then(function (res) {
          if (res.code !== 200) return;
          _this5.extraRewards = (res.data.rewardList || []).filter(function (r) {
            return r.rewardCategory == 2;
          }) || [];
          console.log("this.baseReward", _this5.baseReward);
        });
      }
      // 打开人工审核弹窗
      this.currentRow = row;
      this.reviewForm = {
        status: '',
        reward: '',
        remark: row.remark.warn || '',
        qualityLevel: null
      };
      this.showReviewDialog = true;
    },
    // 提交人工审核
    submitReview: function submitReview() {
      var _this6 = this;
      this.$refs.reviewFormRef.validate(function (valid) {
        if (!valid) return;
        if (!_this6.currentRow || !_this6.currentRow.id) {
          _this6.$message.error('缺少审核记录');
          return;
        }
        var statusMap = {
          'pass': 6,
          'reject': 5,
          'pass_no_reward': 7
        };
        if (_this6.activeMenu === 'premium') {
          statusMap = {
            'pass': 10,
            'reject': 11,
            'pass_no_reward': 7
          };
        }
        var params = {
          id: _this6.currentRow.id,
          action: statusMap[_this6.reviewForm.status] || _this6.reviewForm.status,
          auditRemark: _this6.reviewForm.remark || ''
        };
        if (_this6.activeMenu === 'basic' && _this6.reviewForm.qualityLevel != null) {
          params.qualityLevel = _this6.reviewForm.qualityLevel;
        }
        if (_this6.activeMenu === 'premium' && _this6.reviewForm.status === 'pass') {
          params.rewardId = _this6.reviewForm.reward || '';
        }
        _redbook.default.AddPostAudit(params).then(function (res) {
          if (res.code == 500) {
            _this6.$message.error(res.message);
            return;
          }
          _this6.$message.success('操作成功');
          _this6.showReviewDialog = false;
          _this6.fetchList();
        }).catch(function (err) {
          _this6.$message.error(err.message || '操作失败');
        });
      });
    },
    // 状态变更时，若为不通过则备注必填
    onReviewStatusChange: function onReviewStatusChange(v) {
      if (v === 'reject') {
        this.reviewFormRules.remark = [{
          required: true,
          message: '请填写备注',
          trigger: 'blur'
        }];
      } else {
        this.reviewFormRules.remark = [{
          required: false,
          message: '请填写备注',
          trigger: 'blur'
        }];
      }
      // 优质帖通过时，需要选择奖励
      if (this.activeMenu === 'premium' && v === 'pass') {
        this.reviewFormRules.reward = [{
          required: true,
          message: '请选择奖励',
          trigger: 'change'
        }];
      }
    },
    getActList: function getActList() {
      var _this7 = this;
      var data = {
        startTime: '',
        endTime: '',
        keywords: '',
        page: 1,
        limit: 99999,
        total: 0
      };
      _redbook.default.xyXhsTask(data).then(function (res) {
        _this7.actLists = res.records || [];
        // if (res.records[0] && (this.actId == 'null' || this.actId == '')) {
        //     this.searchForm.taskId = res.records[0].id
        //     this.fetchList(res.records[0].id)
        // }
      });
    }
  },
  mounted: function mounted() {
    this.getActList();
    this.fetchList();
  }
};